import { render, staticRenderFns } from "./list3.vue?vue&type=template&id=2318e3be&scoped=true&"
import script from "./list3.vue?vue&type=script&lang=js&"
export * from "./list3.vue?vue&type=script&lang=js&"
import style0 from "./list3.vue?vue&type=style&index=0&id=2318e3be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2318e3be",
  null
  
)

export default component.exports